import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch jobs with dynamic query parameters
export const fetchAllJobs = async (params = {}) => {
  try {
    // Filter out empty values
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== "" && value !== "All" && value != null
      )
    );

    // Build query string from filtered params
    const queryString = Object.entries(filteredParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${BASE_URL}/jobs${queryString ? `?${queryString}` : ""}`;

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};

// fetch job by id function
export const fetchJobById = async (jobId) => {
  try {
    const response = await axios.get(`${BASE_URL}/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    console.error("Error in fetching job by ID:", error);
    throw error;
  }
};

// api to create a new job
export const createNewJob = async (jobData, token) => {
  try {
    const response = await axios.post(`${BASE_URL}/admin/jobs`, jobData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating new job:", error);
    throw error;
  }
};

// api to like a job
export const likeJob = async (jobId, userId) => {
  try {
    const response = await axios.put(`${BASE_URL}/jobs/${jobId}/likes`, {
      userId,
    });
    return response.data;
  } catch (error) {
    console.error("Error liking/unliking job:", error);
    throw error;
  }
};

// api to unlike a job
export const unlikeJob = async (jobId, userId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/jobs/${jobId}/unlikes/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error liking/unliking job:", error);
    throw error;
  }
};

// api to handle job application
export const applyToJob = async (jobId, userId) => {
  try {
    const response = await axios.put(`${BASE_URL}/jobs/${jobId}/applies`, {
      userId,
    });
    return response.data;
  } catch (error) {
    console.error("Error applying to job:", error);
    throw error;
  }
};

// api to add comment to a job
export const addCommentToJob = async (jobId, commentData, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/jobs/${jobId}/comment`,
      commentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding comment to job:", error);
    throw error;
  }
};

// api to delete comment from a job
export const deleteCommentFromJob = async (jobId, commentId, token) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/jobs/${jobId}/comment/${commentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting comment from job:", error);
    throw error;
  }
};

// ================ ADMIN JOB APIs ================

// api to update a job (Admin only)
export const updateJob = async (jobId, jobData, token) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/admin/jobs/${jobId}`,
      jobData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating job:", error);
    throw error;
  }
};

// api to delete a job (Admin only)
export const deleteJob = async (jobId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/admin/jobs/${jobId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting job:", error);
    throw error;
  }
};
